import { AdPlacementsGroupType } from '@bingads-webui-campaign-react/ad-placement-consts';

import { transformToTemplateData as imageExtensionTransformer } from './image-extension/index';
import { transformToTemplateData as msanImageAdTransformer } from './msan-image-ad/index';
import { transformToTemplateData as perfMaxTransformer } from './perf-max/index';
import { transformToTemplateData as searchImageAdTransformer } from './search-image-ad/index';
import { transformToTemplateData as streamlinedSignupTransformer } from './streamlined-signup/index';
import { transformToTemplateData as appAdTransformer } from './app-ad/index';
import { transformToTemplateData as adLibraryTransformer } from './ad-library/index';
import { transformToTemplateData as responsiveSearchAdTransformer } from './responsive-search-ad/index';
import { transformToTemplateData as dynamicSearchAdTransformer } from './dynamic-search-ad/index';

export const GroupTypeTransformerMapping = {
  [AdPlacementsGroupType.imageExtension]: imageExtensionTransformer,
  [AdPlacementsGroupType.msanImageAd]: msanImageAdTransformer,
  [AdPlacementsGroupType.perfMax]: perfMaxTransformer,
  [AdPlacementsGroupType.searchImageAd]: searchImageAdTransformer,
  [AdPlacementsGroupType.streamlinedSignup]: streamlinedSignupTransformer,
  [AdPlacementsGroupType.adLibrary]: adLibraryTransformer,
  [AdPlacementsGroupType.msanBoostImageAd]: msanImageAdTransformer,
  [AdPlacementsGroupType.appAd]: appAdTransformer,
  [AdPlacementsGroupType.appAdStart]: appAdTransformer,
  [AdPlacementsGroupType.responsiveSearchAd]: responsiveSearchAdTransformer,
  [AdPlacementsGroupType.dynamicSearchAd]: dynamicSearchAdTransformer,
};
